export const STORE_ACCOUNT = 'store/account'
